// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>8</span>&nbsp;&nbsp;Keep me as the apple of your eye;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;hide me under the shadow of your wings,<br> </p> </div></div>";
// Exports
module.exports = code;